/**
 * Search Experiment
 */
import { App } from '~/app';

// import SearchAutocomplete from './SearchAutocomplete.vue';
// import SearchFilters from './SearchFilters.vue';
// import SearchListing from './SearchListing.vue';
// import SearchPagination from './SearchPagination.vue';
// import SearchQuery from './SearchQuery.vue';
// import SearchSorting from './SearchSorting.vue';

export default (app: App) => {
    app.logger.debug('[Stockland FE] Initialise Search Experiment Component');

	 // These Vue components are not used - commenting out to prevent compilation in the completed bundle
	 // app.vueApp.component('search-autocomplete-experiment', SearchAutocomplete);
	 // app.vueApp.component('search-filters-experiment', SearchFilters);
	 // app.vueApp.component('search-listing-experiment', SearchListing);
	 // app.vueApp.component('search-pagination-experiment', SearchPagination);
	 // app.vueApp.component('search-query-experiment', SearchQuery);
	 // app.vueApp.component('search-sorting-experiment', SearchSorting);
};
